/* AB-Foliendesign – Warenkorb-Optimierung v1.0
   Verändert keine Warenkorbpositionen, Rabatte oder Zepto-Eingaben.
   Ergänzt nur vorhandene Erfolgsmeldungen und vorhandene Zusatzbereiche.
*/
(function () {
  'use strict';
  if (window.__abCartConversionV1) return;
  window.__abCartConversionV1 = true;

  var configNode = document.getElementById('ab-cart-conversion-config');
  var config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {
    config = {};
  }

  var root = config.rootUrl || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var cartUrl = config.cartUrl || root + 'cart';
  var checkoutUrl = root + 'checkout';
  var currency = config.currency || 'EUR';
  var mobile = window.matchMedia('(max-width: 749px)');
  var topSyncTimer = null;
  var topSyncNumber = 0;
  var scanQueued = false;

  function makeLink(text, href, secondary) {
    var link = document.createElement('a');
    link.href = href;
    link.className = 'ab-cart-action' + (secondary ? ' ab-cart-action--secondary' : '');
    link.textContent = text;
    return link;
  }

  function enhanceFeedback(node) {
    if (!node || node.querySelector('.ab-cart-feedback__actions')) return;
    var original = node.querySelector('.cart-feedback-inline__link[href]');
    var message = node.querySelector('.cart-feedback-inline__text');
    var text = message ? message.textContent : node.textContent;
    var isConfirmation = /(?:in den Warenkorb gelegt|im Warenkorb|im Körbchen)/i.test(text || '');
    if (!isConfirmation) return;

    /* Nur vorhandene echte Erfolgsmeldungen erweitern, nicht den Add-to-Cart-Request abfangen. */
    var actions = document.createElement('div');
    actions.className = 'ab-cart-feedback__actions';
    actions.appendChild(makeLink('Zum Warenkorb', cartUrl, false));
    actions.appendChild(makeLink('Direkt zur Kasse', checkoutUrl, true));

    var continueButton = document.createElement('button');
    continueButton.type = 'button';
    continueButton.className = 'ab-cart-feedback__continue';
    continueButton.textContent = 'Weiter einkaufen';
    continueButton.addEventListener('click', function () {
      node.classList.remove('is-visible');
      if (node.classList.contains('add-to-cart-feedback')) node.style.display = 'none';
    });
    actions.appendChild(continueButton);
    node.appendChild(actions);
    node.classList.add('ab-cart-feedback--enhanced');

    if (original) {
      original.classList.add('ab-cart-original-link');
      original.hidden = true;
    }
  }

  function setFoldMode(details) {
    if (!details || !details.isConnected) return;
    details.open = !mobile.matches;
  }

  function makeFold(node, kind, heading) {
    if (!node || node.closest('.ab-cart-fold')) return;
    if (!node.parentNode) return;
    var details = document.createElement('details');
    details.className = 'ab-cart-fold ab-cart-fold--' + kind;
    details.setAttribute('data-ab-cart-fold', kind);

    var summary = document.createElement('summary');
    var title = document.createElement('span');
    title.textContent = heading;
    var chevron = document.createElement('span');
    chevron.className = 'ab-cart-fold__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    summary.appendChild(title);
    summary.appendChild(chevron);

    var content = document.createElement('div');
    content.className = 'ab-cart-fold__content';
    details.appendChild(summary);
    details.appendChild(content);
    node.parentNode.insertBefore(details, node);
    content.appendChild(node);
    setFoldMode(details);
  }

  function formatMoney(cents, code) {
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: code || currency
    }).format(Number(cents || 0) / 100);
  }

  function setTopBusy(busy) {
    document.querySelectorAll('[data-ab-cart-top]').forEach(function (panel) {
      var button = panel.querySelector('[data-ab-top-checkout]');
      if (button) button.disabled = busy;
    });
  }

  function syncTop() {
    if (!document.querySelector('[data-ab-cart-top]')) return;
    var sequence = ++topSyncNumber;
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function (cart) {
      if (sequence !== topSyncNumber) return;
      document.querySelectorAll('[data-ab-cart-top]').forEach(function (panel) {
        panel.hidden = Number(cart.item_count || 0) < 1;
        var total = panel.querySelector('[data-ab-cart-total]');
        var button = panel.querySelector('[data-ab-top-checkout]');
        var error = panel.querySelector('[data-ab-cart-error]');
        if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
        if (button) button.disabled = Number(cart.item_count || 0) < 1;
        if (error) error.hidden = true;
      });
    }).catch(function () {
      if (sequence !== topSyncNumber) return;
      document.querySelectorAll('[data-ab-cart-top]').forEach(function (panel) {
        var button = panel.querySelector('[data-ab-top-checkout]');
        var error = panel.querySelector('[data-ab-cart-error]');
        if (button) button.disabled = true;
        if (error) error.hidden = false;
      });
    });
  }

  function scheduleTopSync() {
    if (!document.querySelector('[data-ab-cart-top]')) return;
    clearTimeout(topSyncTimer);
    topSyncTimer = setTimeout(syncTop, 120);
  }

  function scan() {
    document.querySelectorAll('.cart-feedback-inline, .add-to-cart-feedback').forEach(enhanceFeedback);

    /* Nur die beiden bekannten, vorhandenen Shop-Bereiche umschließen. */
    document.querySelectorAll('#main-cart-footer .free-shipping-progress, #main-cart-items .free-shipping-progress').forEach(function (node) {
      makeFold(node, 'shipping', 'Versandvorteil');
    });
    document.querySelectorAll('#main-cart-footer .ab-cart-upsell, #main-cart-items .ab-cart-upsell').forEach(function (node) {
      makeFold(node, 'upsell', 'Darf es etwas mehr sein?');
    });

    /* Auch nach einem Shopify-Section-Reload die neue obere Kasse synchronisieren. */
    var newTop = false;
    document.querySelectorAll('[data-ab-cart-top]').forEach(function (panel) {
      if (panel.dataset.abTopInitialized === 'true') return;
      panel.dataset.abTopInitialized = 'true';
      newTop = true;
    });
    if (newTop) scheduleTopSync();
  }

  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  function init() {
    scan();

    /* Der bestehende Upsell wird per JavaScript nachgeladen.
       Ein Observer erkennt ihn und neu gerenderte Warenkorb-Sections. */
    var observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    var handleBreakpoint = function () {
      document.querySelectorAll('.ab-cart-fold').forEach(setFoldMode);
    };
    if (mobile.addEventListener) mobile.addEventListener('change', handleBreakpoint);
    else if (mobile.addListener) mobile.addListener(handleBreakpoint);

    document.addEventListener('cart:updated', scheduleTopSync);
    document.addEventListener('cart:refresh', scheduleTopSync);
    document.addEventListener('shopify:section:load', function () {
      scheduleScan();
      scheduleTopSync();
    });

    /* Dawn veröffentlicht dieses Ereignis nach erfolgreichen Warenkorb-Updates. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleTopSync);
    }

    /* Bei einer beginnenden Mengenänderung nicht mit einem alten Betrag zur Kasse gehen. */
    document.addEventListener('change', function (event) {
      if (event.target.matches('#cart input[name="updates[]"], #cart .quantity__input')) {
        setTopBusy(true);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
